import defaultState from 'redux/defaultState';

export default (data = defaultState.data, action) => {
  if (action.type === 'DATA_UPDATE') {
    return {
      ...data,
      ...action.payload
    };
  }

  if (action.type === 'DATA_REPLACE') {
    return {
      ...action.payload
    };
  }

  if (action.type === 'DATA_CLEAR') {
    return {};
  }

  return data;
};
